/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

const getServiceId = (title) => title.toLowerCase().replace(/\s+/g, '-').replace(/\//g, '');

export default function ServicesNumbered({ data }) {
  return (
    <section id="services-section" className="container mx-auto px-4 lg:px-8 py-20 relative z-10">
      <div className="text-center mb-12">
        <span className="section-eyebrow">Our Services</span>
        <h2 className="text-4xl lg:text-5xl font-bold text-white mt-4 mb-4">
          Engineering across <span className="neon-text">every layer</span>
        </h2>
        <p className="text-blue-100 text-lg max-w-2xl mx-auto">
          Six services, one team. Senior-led from kickoff to ship.
        </p>
      </div>

      <div className="numbered-service-list max-w-5xl mx-auto">
        {data.map((item, idx) => {
          const id = getServiceId(item.title);
          const num = String(idx + 1).padStart(2, '0');
          return (
            <a
              key={item.title}
              id={id}
              href="/services"
              className="numbered-service-row"
            >
              <span className="numbered-service-index">{num}</span>
              <div className="numbered-service-content">
                <span className="numbered-service-title">{item.title}</span>
                <span className="numbered-service-desc">{item.description}</span>
              </div>
              <span className="numbered-service-arrow" aria-hidden="true">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>
            </a>
          );
        })}
      </div>
    </section>
  );
}
